import classnames from 'classnames';
import React from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  status: string;
}

interface StatusColors {
  [key: string]: string;
}

const StatusLabel: React.FC<Props> = ({ status }) => {
  const { translate } = useTranslator(['statusLabels']);

  const statusColors: StatusColors = {
    Open: '#ff8585',
    Closed: '#dcdfe3',
    Draft: '#ffffff',
  };

  const statusLabel: `${string}:${string}` =
    `statusLabels:statuses.${status.toUpperCase()}` as `${string}:${string}`;

  return (
    <div
      className={classnames(
        'inline-block b-radius-3 py1 px3 black-1 normal truncate',
        {
          'b-3': status === 'Draft',
        }
      )}
      style={{ backgroundColor: statusColors[status] }}
    >
      {translate(statusLabel)}
    </div>
  );
};

export default StatusLabel;
